// extracted by mini-css-extract-plugin
module.exports = {"language":"_eW","languageItem":"_eX","active":"_eY"};